import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTableHeader]',
  standalone: false,
})
export class TableHeaderDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
